import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";

// authentication
import ProtectedRoute from "utils/ProtectedRoute";
import { path } from "./constant";

// dashboard routing
const DashboardDefault = Loadable(
  lazy(() => import("views/dashboard/Default"))
);

// SaasSubscriptionFeeCalculator routing
const SaasSubscriptionFeeCalculator = Loadable(
  lazy(() => import("views/calculators/saas-subscription-fee"))
);

// ECommerceProductFeeCalculator routing
const ECommerceProductFeeCalculator = Loadable(
  lazy(() => import("views/calculators/e-commerce-product-profit"))
);

// EmergencyFundCalculator routing
const EmergencyFundCalculator = Loadable(
  lazy(() => import("views/calculators/emergency-fund"))
);

// CashRunwayCalculator routing
const CashRunwayCalculator = Loadable(
  lazy(() => import("views/calculators/cash-runway"))
);

// FinancialForecast routing
const FinancialForecast = Loadable(
  lazy(() => import("views/financial-forecast"))
);
const Assumptions = Loadable(
  lazy(() => import("views/financial-forecast/assumptions"))
);
const SubscriberAcquisitions = Loadable(
  lazy(() => import("views/financial-forecast/subscriber-acquisitions"))
);
const Revenue = Loadable(
  lazy(() => import("views/financial-forecast/revenue"))
);
const CostAndExpenses = Loadable(
  lazy(() => import("views/financial-forecast/cost-and-expenses"))
);
const HiringPlan = Loadable(
  lazy(() => import("views/financial-forecast/hiring-plan"))
);
const ProfitAndLoss = Loadable(
  lazy(() => import("views/financial-forecast/profit-and-loss"))
);
const FreeCashFlow = Loadable(
  lazy(() => import("views/financial-forecast/free-cash-flow"))
);
const CompanyDetails = Loadable(
  lazy(() => import("views/financial-forecast/company-details"))
);
const Customization = Loadable(lazy(() => import("views/customization")));

// utilities routing
const UtilsTypography = Loadable(
  lazy(() => import("views/utilities/Typography"))
);
const UtilsColor = Loadable(lazy(() => import("views/utilities/Color")));
const UtilsShadow = Loadable(lazy(() => import("views/utilities/Shadow")));
const UtilsMaterialIcons = Loadable(
  lazy(() => import("views/utilities/MaterialIcons"))
);
const UtilsTablerIcons = Loadable(
  lazy(() => import("views/utilities/TablerIcons"))
);

// sample page routing
const SamplePage = Loadable(lazy(() => import("views/sample-page")));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: "/",
      element: <FinancialForecast />,
    },
    {
      path: path.FINANCIAL_FORECAST,
      element: <FinancialForecast />,
    },
    {
      path: path.FINANCIAL_FORECAST_COMPANY_DETAILS,
      element: <CompanyDetails />,
    },
    {
      path: path.FINANCIAL_FORECAST_ASSUMPTIONS,
      element: <Assumptions />,
    },
    {
      path: path.FINANCIAL_FORECAST_SUBSCRIBER_CQUISITIONS,
      element: <SubscriberAcquisitions />,
    },
    {
      path: path.FINANCIAL_FORECAST_REVENUE,
      element: <Revenue />,
    },
    {
      path: path.FINANCIAL_FORECAST_COST_AND_EXPENSES,
      element: <CostAndExpenses />,
    },
    {
      path: path.FINANCIAL_FORECAST_HIRING_PLAN,
      element: <HiringPlan />,
    },
    {
      path: path.FINANCIAL_FORECAST_PROFIT_LOSS,
      element: <ProfitAndLoss />,
    },
    {
      path: path.FINANCIAL_FORECAST_FREECASH_FLOW,
      element: <FreeCashFlow />,
    },
    {
      path: path.CUSTOMIZATION,
      element: <Customization />,
    },
    {
      path: path.PERFORMANCE_ANALYSIS,
      element: <DashboardDefault />,
      // element: <Dashboard />,
    },
    {
      path: path.PERFORMANCE_ANALYSIS,
      children: [
        {
          path: "default",
          element: <DashboardDefault />,
        },
      ],
    },
    {
      path: path.SAAS_SUBSCRIPTION_FEE_CALCULATOR,
      element: <SaasSubscriptionFeeCalculator />,
    },
    {
      path: "/calculators/e-commerce-product-profit",
      element: <ECommerceProductFeeCalculator />,
    },
    {
      path: path.EMERGENCY_FUND_CALCULATOR,
      element: <EmergencyFundCalculator />,
    },
    {
      path: path.CASH_RUNWAY_CALCULATORS,
      element: <CashRunwayCalculator />,
    },
    {
      path: "utils",
      children: [
        {
          path: "util-typography",
          element: <UtilsTypography />,
        },
      ],
    },
    {
      path: "utils",
      children: [
        {
          path: "util-color",
          element: <UtilsColor />,
        },
      ],
    },
    {
      path: "utils",
      children: [
        {
          path: "util-shadow",
          element: <UtilsShadow />,
        },
      ],
    },
    {
      path: "icons",
      children: [
        {
          path: "tabler-icons",
          element: <UtilsTablerIcons />,
        },
      ],
    },
    {
      path: "icons",
      children: [
        {
          path: "material-icons",
          element: <UtilsMaterialIcons />,
        },
      ],
    },
    {
      path: "sample-page",
      element: <SamplePage />,
    },
  ],
};

export default MainRoutes;
